<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="项目/联系人/电话" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.customer_id"  clearable filterable  placeholder="甲方">
                                        <Option :value="item.id" v-for="(item,index) in customerList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.head_id"  clearable filterable  placeholder="负责人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.status"  clearable filterable  placeholder="项目进度">
                                        <Option :value="1">项目立项</Option>
                                        <Option :value="2">审批驳回</Option>
                                        <Option :value="7">签署完成</Option>
                                        <Option :value="-1">项目取消</Option>
                                        <Option :value="-2">项目暂停</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建项目</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="project_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" @on-selection-change="tableCheckAll" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #name="{ row }">
                                    <div @click="showData(row.project_id)" class="d-width text-primary cursor" :title="row.name">
                                        <span>{{row.name}}</span>
                                    </div>
                                </template>
                                <template #company="{ row }">
                                    <div @click="customerData(row.customer_id)" class="d-width cursor" :title="row.company">
                                        <Poptip trigger="hover" title="联系方式" >
                                            <span>{{row.company}}</span>
                                            <template #content>
                                                <p>公司：{{row.company}}</p>
                                                <p>称呼：{{row.customer_real_name}}</p>
                                                <p>电话：{{row.customer_mobile}}</p>
                                                <p v-if="!!row.customer_wechat">微信：{{row.customer_wechat}}</p>
                                            </template>
                                        </Poptip>
                                    </div>
                                </template>
                                <template #type_id="{ row }">
                                    <div class="d-width" :title="row.type_name">
                                        <Tag>{{row.type_name}}</Tag>
                                    </div>
                                </template>
                                <template #money="{ row }">
                                    <div class="d-width" :title="row.money">
                                        <strong class="text-primary">{{row.money}}</strong>
                                    </div>
                                </template>
                                <template #contract_money="{ row }">
                                    <div class="d-width" :title="row.contract_money">
                                        <strong class="text-success">{{row.contract_money}}</strong>
                                    </div>
                                </template>
                                <template #contract_signa_name="{ row }">
                                    <div class="d-width" :title="row.contract_signa_name">
                                        {{row.contract_signa_name}}
                                    </div>
                                </template>
                                <template #contract_end_time="{ row }">
                                    <div class="d-width" :title="row.contract_start_time + ' 至 ' + row.contract_end_time">
                                         {{row.contract_end_time ?? '-'}}
                                    </div>
                                </template>

                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 7" color="green" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" :text="row.status_name" />
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && row.status === 1" @click="examineData(row.project_id, row.name)">审批</a>
                                    <Divider v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && row.status === 1" type="vertical"/>
                                    <a class="text-font-sm text-orange" title="项目施工" v-if="row.status === 7" @click="workTrueData(row.project_id, row.name)">施工</a>
                                    <Divider v-if="row.status === 7" type="vertical"/>
                                    <a class="text-font-sm text-violet" @click="logData(row.project_id, row.name)">日志</a>
                                    <Divider type="vertical"/>
                                    <a class="text-font-sm text-primary" v-if="row.status > 0 && ($store.state.userinfo.admin_id === row.head_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)" @click="editData(row.project_id)">编辑</a>
                                    <Divider type="vertical" v-if="row.status > 0 && ($store.state.userinfo.admin_id === row.head_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)" />
                                    <a class="text-font-sm text-999" v-if="$store.state.userinfo.admin_id === row.head_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2" @click="delData(row.project_id , index)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page">
                                <div class="em-page-btn">
                                    <span class="text-999">选中 <em class="text-danger">{{selectCount}}</em> 条记录</span>
                                    <Divider type="vertical" />
                                    <span class="text-999 mr10">批量</span>
                                    <ButtonGroup size="default">
                                        <Button @click="allDelData()" >删除</Button>
                                    </ButtonGroup>
                                </div>
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                    <!-- 客户详情 -->
                    <customer-show-modal v-if="is_customer" ref="CustomerRef"></customer-show-modal>

                    <!-- 立项审批  -->
                    <init-examine-modal v-if="is_examine" ref="ExamineRef" @trueHandler="saveData"></init-examine-modal>

                    <!-- 项目日志  -->
                    <log-modal v-if="is_log" ref="LogRef"></log-modal>

                    <!-- 项目施工  -->
                    <work-true-modal v-if="is_work_true" ref="WorkTrueRef" @trueHandler="saveData"></work-true-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {getProjectInitList, getProjectConfig, deleteProject, deleteAllProject} from '@/apis/project'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../public/Create";
import LogModal from "../public/Log";
import ShowModal from "../public/Show";
import InitExamineModal from "../public/InitExamine";
import CustomerShowModal from "../../customer/index/Show";
import WorkTrueModal from "../public/WorkTrue";
export default {
    name: "ProjectInit",
    components: {
        WorkTrueModal,
        Headers, Side, AddModal, ShowModal, InitExamineModal, LogModal, CustomerShowModal
    },
    data () {
        return {
            typeList: [],
            customerList: [],
            userList: [],

            search: {
                name: '',
                type_id: '',
                customer_id: '',
                head_id: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    type: 'selection',
                    width: 55,
                    align: 'center',
                    fixed : 'left'
                },
                {
                    title: '项目名称',
                    key: 'name',
                    slot: 'name',
                    minWidth: 220
                },
                {
                    title: '甲方',
                    key: 'company',
                    slot: 'company',
                    width: 200
                },
                {
                    title: '项目金额',
                    key: 'money',
                    slot: 'money',
                    width: 120
                },
                {
                    title: '合同金额',
                    key: 'contract_money',
                    slot: 'contract_money',
                    width: 120
                },
                {
                    title: '签订人',
                    key: 'contract_signa_name',
                    slot: 'contract_signa_name',
                    width: 140
                },
                {
                    title: '合同期',
                    key: 'contract_end_time',
                    slot: 'contract_end_time',
                    width: 120
                },

                {
                    title: '项目进度',
                    key: 'status',
                    slot : 'status',
                    width:120
                },
                {
                    title: '项目类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 120
                },
                {
                    title: '负责人',
                    key: 'head_name',
                    width: 120
                },

                {
                    title: '更新',
                    key: 'update_time',
                    width:150
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    width : 190,
                    fixed : 'right'
                }
            ],
            is_create : false,
            is_show : false,
            is_examine : false,
            is_log : false,
            is_customer : false,
            is_work_true : false,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：开始施工
         time: 2025/12/20 17:18
         **/
        workTrueData(project_id, name){
            let that = this;
            that.is_work_true = true;
            setTimeout(function(){
                that.$refs.WorkTrueRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 16:24
         **/
        customerData(customer_id){
            let that = this;
            that.is_customer = true;
            setTimeout(function(){
                that.$refs.CustomerRef.show(customer_id);
            })
        },
        /**
         功能：审批
         time: 2025/12/20 10:39
         **/
        examineData(project_id, name){
            let that = this;
            that.is_examine = true;
            setTimeout(function(){
                that.$refs.ExamineRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                type_id: '',
                customer_id: '',
                head_id: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2025/12/18 14:07
         **/
        getConfig(){
            let that = this;
            getProjectConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.customerList = e.data.customerList ?? [];
                that.userList = e.data.userList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getProjectInitList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/19 11:30
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2025/12/19 15:55
         **/
        editData(project_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(project_id);
            })
        },
        /**
         功能：
         time: 2025/12/19 16:04
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        logData(project_id, name ){
            let that = this;
            that.is_log = true;
            setTimeout(function(){
                that.$refs.LogRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        showData(project_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(project_id);
            })
        },
        /**
         功能：
         time: 2025/12/19 16:04
         **/
        tableCheckAll(){
            let that = this;
            const data = that.$refs.selection.getSelection();
            that.selectCount = data.length;
        },
        /**
         功能：
         time: 2025/12/19 16:05
         **/
        delData(project_id, index){
            let that = this;
            if(!project_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteProject(project_id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        /**
         功能：
         time: 2025/12/19 16:07
         **/
        allDelData(){
            let that = this;
            const data = that.$refs.selection.getSelection();
            if(data.length <= 0){
                that.$Message.error({ background: true, content:'至少选择一条记录'});
                return false;
            }
            let projectIds = [];
            for(var i  = 0; i < data.length; i++ ){
                projectIds.push(data[i].project_id);
            }
            if(projectIds.length > 0){
                this.$Modal.confirm({
                    title: '批量删除记录',
                    content: '此操作将批量删除记录不可恢复, 是否继续?',
                    onOk: () => {
                        deleteAllProject(projectIds).then( e =>{
                            that.$Message.success({ background: true,duration:3, content:e.msg});
                            that.getList();
                        })
                    },
                    onCancel: () => {}
                });
            }
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
